import React, { useEffect, useRef, useState } from "react";
import { Switch, Redirect, useHistory } from "react-router-dom";
import { BottomNavigation, PrivateRoute } from '@Components/';
import { Box } from '@curves/ui-base';
import { MeasurementDashboardPage, MeasurementDetailPage, MeasurementReportPage } from "@Local/Measurement/";
import { MEASURE_DASHBOARD_ROUTER, MEASURE_DETAIL_ROUTER, MEASURE_REPORT_ROUTER, MEASURE_ROUTER } from "@Router/routerPath";
import { MeasurementProvider } from "@Local/Measurement/Context/MeasurementContext";
import { FOOTER_TYPE, HEADER_TYPE, THEME_TYPE } from "@Constants/";
import { MEMBER_SITE_LOGON_TYPE } from "@Constants/dataEnums";
import { useMainLayoutContext } from "@Local/Components/Layout/Context/MainLaydoutContext";
import useMemberInbodyApi from "@Apis/useMemberInbodyApi";
import useEmployeeInbodyApi from "@Apis/useEmployeeInbodyApi";
import { isEmpty, localUser } from "@Util/utils";
import InsightsIcon from "@mui/icons-material/Insights";
import ArticleIcon from "@mui/icons-material/Article";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import TrendChartDialogBox from "./Dialog/TrendChartDialogBox";

const measureNavItems = [
    {
        label: "分析",
        value: MEASURE_DASHBOARD_ROUTER,
        icon: <InsightsIcon />,
    },
    {
        label: "比較",
        value: MEASURE_DETAIL_ROUTER,
        icon: <CompareArrowsIcon />,
    },
    {
        label: "報表",
        value: MEASURE_REPORT_ROUTER,
        icon: <ArticleIcon />,
    },
];

const MeasurementPage = props => {
    const [measureID, setMeasureID] = useState(0);
    const [measureOptions, setMeasureOptions] = useState([]);
    const [reportFocusMode, setReportFocusMode] = useState(false);
    const pathname = props.location.pathname;
    const dialogRef = useRef(null);
    const history = useHistory();

    const { getMemberInbodyOptionsApi } = useMemberInbodyApi();
    const { getEmployeeInbodyOptionsApi } = useEmployeeInbodyApi();
    const { logonType } = localUser.get() || {};
    const {
        enableMemberSmartFitnessBand = false,
        enableVip = false,
        visibleNewFeature = false,
    } = localUser.getUiRole() || {};
    
    const visibleNav = enableVip || (enableMemberSmartFitnessBand && visibleNewFeature);
    const { setHeaderType, setFooterType, setThemeType } = useMainLayoutContext();

    useEffect(
        () => {
            setHeaderType(HEADER_TYPE.LOGO_WHITE | HEADER_TYPE.HIDE_BACKGROUND | HEADER_TYPE.UNFIXED);
            setFooterType(FOOTER_TYPE.HIDE);
            setThemeType(THEME_TYPE.DARK);
        },
        // eslint-disable-next-line
        [],
    );

    // 進入量身區塊時，將 measureID 設為最新一次量身（options 第一筆）
    useEffect(
        () => {
            const fetchLatestMeasureID = async () => {
                const resp =
                    logonType === MEMBER_SITE_LOGON_TYPE.MEMBER ? await getMemberInbodyOptionsApi() : logonType === MEMBER_SITE_LOGON_TYPE.EMPLOYEE ? await getEmployeeInbodyOptionsApi() : null;
                if (resp && !isEmpty(resp?.measureOption)) {
                    const options = resp.measureOption;
                    setMeasureOptions(options);
                    const latestId = options[0]?.value;
                    if (latestId != null) {
                        setMeasureID(latestId);
                    }
                }
            };
            fetchLatestMeasureID();
        },
        // eslint-disable-next-line
        [logonType],
    );

    const handleMeasureNavChange = (event, newValue) => {
        if (newValue === pathname) return;
        history.push(newValue);
    };

    return (
        <MeasurementProvider value={{ measureID, setMeasureID, measureOptions, dialogRef, reportFocusMode, setReportFocusMode }}>
            {visibleNav && !reportFocusMode && (
                <Box className={"bottom-navigation"}>
                    <BottomNavigation className={"measurement-menu--container"}
                                      onChange={handleMeasureNavChange}
                                      items={measureNavItems}
                                      value={pathname}
                                      showLabels={true}
                    />
                </Box>
            )}

            <Switch>
                <PrivateRoute path={MEASURE_DASHBOARD_ROUTER} as={MeasurementDashboardPage} exact />
                <PrivateRoute path={MEASURE_DETAIL_ROUTER} as={MeasurementDetailPage} exact />
                <PrivateRoute path={MEASURE_REPORT_ROUTER} as={MeasurementReportPage} measureID={measureID} setMeasureID={setMeasureID} exact />
                {visibleNav
                    ? (<Redirect from={MEASURE_ROUTER} to={MEASURE_DASHBOARD_ROUTER} exact />)
                    : (<Redirect from={MEASURE_ROUTER} to={MEASURE_REPORT_ROUTER} exact />)}
            </Switch>
            <TrendChartDialogBox ref={dialogRef} />
        </MeasurementProvider>
    );
};

export default MeasurementPage;
